module.exports = __webpack_public_path__ + "ClientApp/content/notFound.jpg";